import { Link } from 'react-router-dom';

import SectionHeader from '@ifit/mp-section-header';

export default SectionHeader(Link);
